import {
  daysInStockColors,
  percentOfPercaysoColors,
  marketDemandColors,
  dealerTypeColors,
  nearlyNewColors,
  modelColors,
  mileageColors
} from '../constants/chartColors'

export function createChartSections(dataGetters) {
  return [
    {
      key: 'days-in-stock',
      title: 'Days in Stock',
      primaryData: dataGetters.primaryDaysInStockData,
      competitorData: dataGetters.competitorDaysInStockData,
      colors: daysInStockColors,
      totalLabel: 'Days',
      singleColumn: false
    },
    {
      key: 'percayso-stock',
      title: 'Percayso Stock',
      primaryData: dataGetters.primaryPercentData,
      competitorData: dataGetters.competitorPercentData,
      colors: percentOfPercaysoColors,
      totalLabel: 'Percent',
      singleColumn: false
    },
    {
      key: 'market-demand',
      title: 'Market Demand (0-100)',
      primaryData: dataGetters.primaryMarketDemandData,
      competitorData: dataGetters.competitorMarketDemandData,
      colors: marketDemandColors,
      totalLabel: 'Demand',
      singleColumn: false
    },
    {
      key: 'model',
      title: 'Model',
      primaryData: dataGetters.primaryModelData,
      competitorData: dataGetters.competitorModelData,
      colors: modelColors,
      totalLabel: 'Cars in total',
      singleColumn: false
    },
    {
      key: 'dealer-type',
      title: 'Dealer Type',
      primaryData: dataGetters.primaryDealerTypeData,
      competitorData: dataGetters.competitorDealerTypeData,
      colors: dealerTypeColors,
      totalLabel: 'Type',
      singleColumn: false
    },
    {
      key: 'nearly-new',
      title: 'Nearly New',
      primaryData: dataGetters.primaryNearlyNewData,
      competitorData: dataGetters.competitorNearlyNewData,
      colors: nearlyNewColors,
      totalLabel: 'Nearly New',
      singleColumn: false
    },
    {
      key: 'mileage',
      title: 'Mileage',
      primaryData: dataGetters.primaryMileageData,
      competitorData: dataGetters.competitorMileageData,
      colors: mileageColors,
      totalLabel: 'Mileage',
      singleColumn: false
    }
  ]
}
